import installer from "./en/installer"
import ambassadors from "./en/ambassadors"
import career from "./en/career"
import about from "./en/about"
import metaTags from "./en/meta-tags"
import resaleAgreements from "./en/resale-agreements"
import marketplace from "./en/marketplace"
import footer from "./en/footer"
import getBestPrice from "./en/get-best-price"
import solarLeasing from "./en/solar-leasing"
import communitySolarConsumer from "./en/community-solar-consumer"
import sellSurplus from "./en/sell-surplus"
import tender from "@common/translations/en/tender"
import featureRelease from "@common/translations/en/feature-release"
export default {
  installer,
  ambassadors,
  career,
  about,
  marketplace,
  footer,
  getBestPrice,
  "solar-leasing": solarLeasing,
  "community-solar-consumer": communitySolarConsumer,
  "sell-surplus": sellSurplus,
  "feature-release": featureRelease,
  navigation: {
    home: "Home",
    blogs: "Blogs",
    blog: "Blog",
    "calculate-savings": "Calculate my savings",
    help: "Help",
    "about-us": "About us",
    "our-mission": "Our mission",
    "become-ambassador": "Become an ambassador",
    careers: "Careers",
    "sign-in": "Sign in",
    "sign-up": "Sign up",
    documentation: "Documentation",
    contact: "Contact",
    menu: "Menu",
    video: "Video",
    other: "Other",
    "at-my-place": "At my place",
    "blog-items": {
      "all-articles": "All Articles",
      series: "Series",
      topics: "Topics",
    },
    solutions: {
      title: "Solutions",
      "financing-solar-projects": "Financing for solar projects",
      "host-community-solar-project": "Host a community solar project",
      "join-community-solar-project": "Join a community solar project",
      "project-management-platform": {
        name: "Project Management Platform",
        description: "Simplify the management of your solar projects.",
      },
      "project-assistance": {
        name: "Project Assistance",
        description: "Receive turnkey projects.",
      },
      "administrative-management": {
        name: "Administrative Management",
        description: "Automate your administrative procedures.",
      },
      "photovoltaic-studies": {
        name: "Photovoltaic Studies",
        description: "Online proposals accessible via mini-site.",
      },
    },
  },

  footer: {
    "products-for-installers": "Solutions for professionals",
    "find-clients": "New customers",
    administration: "Administrative management",
    "digital-sales-tools": "Online studies",
    resources: "Resources",
    documentation: "Professional documentation",
    guide: "Solar guide",
    blog: "All articles",
    "support-centre": "Customer support",
    partners: "Partnerships",
    enterprise: "Business",
    home: "Home",
    "about-us": "About us",
    "company-values": "Company Values",
    pricing: "Pricing",
    newsletter: "Solar Project Newsletter",
    "subscribe-newsletter": "News, updates, exclusives: be at the forefront.",
    "your-email": "Enter your email",
    copyright: `${new Date().getFullYear()} © projetsolaire. All rights reserved.`,
    "terms-and-conditions": "Legal notice",
    "privacy-policy": "Privacy Statement",
    "contact-us": "Contact",
    press: "Press",
    technology: "Technology",
  },

  "reset-password": {
    title: "Recover your password",
    subtitle:
      "Entrez l'adresse email que vous avez utilisée lors de votre inscription, et nous vous enverrons un email automatique pour vous réinitialiser votre mot de passe.",
    "check-your-inbox": "vérifiez votre boîte de réception",
    type: {
      householder: "Householder",
      installer: "Installer",
    },
    success: {
      title: "vérifiez votre boîte de réception",
      description: "",
    },
    callback: {
      title: "réinitialiser votre mot de passe",
      "description-1":
        "« Pour protéger vos informations, il est nécessaire de choisir et d’utiliser des mots de passe robustes, c’est-à-dire difficiles à retrouver à l’aide d’outils automatisés et à deviner par une tierce personne »",
      "description-2": "www.interieur.gouv.fr",
      anssi: "l’Agence Nationale de la Sécurité des Systèmes d’Information",
      password: "Password",
      "confirm-password": "Confirm password",
      "reset-your-pass-word": "Reset password",
    },
    "forgot-password": {
      title: "Forgot your password ?",
      description:
        "Enter the email address you used when you registered your account, and we will send you a secure password reset email.",
      "select-type": "You are ...",
      email: "Email",
      "reset-your-pass-word": "Reset password",
    },
  },

  "sign-in": {
    title: "Welcome Back! ",
    "type-select": "You are ...",
    "having-trouble": "Having trouble signing in?",
    "keep-me-signed-in": "Keep me signed in",
    "dont-have-an-account": "Don't you have an account? ",
    type: {
      householder: "Householder",
      installer: "Installer",
    },
    errors: {
      "account.locked":
        "”You've tried to log in too many times without success. For security reasons, your account is locked for 15 minutes. Please wait or reset your password if needed. ",
    },
  },

  "sign-up": {
    title:
      "Welcome. Start your <span class='bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-yellow-400'>solar</span> journey today.",
    tc: " By creating an account, you agree to the <a class='underline' href='/help/guides/installers/legal/declaration-de-confidentialite'>terms & conditions</a>, and our <a class='underline' href='/help/guides/installers/legal/declaration-de-confidentialite'>privacy policy</a>.",
    "already-registered": "Already using Projetsolaire?",
    "company-name": "Votre raison sociale",
    "enter-your-company-name": "Entrez votre raison sociale",
    "password-confirm": "Confirmez votre mot de passe",
    type: {
      householder: "Householder",
      installer: "Installer",
    },
    success: {
      title:
        "Bienvenue ! Veuillez consulter votre courrier électronique avant d'accéder au service élance.",
      description:
        'Veuillez consulter votre boîte mail afin de confirmer la création de votre compte. Si vous ne voyez pas l\'email de confirmation tout de suite, veuillez vérifier votre dossier "spam" ou "courrier indésirable" et marquez-le "non-spam". Le message de confirmation s\'y retrouve parfois par erreur. Si vous avez une question n\'hésitez pas à nous contacter par courrier électronique.',
    },
    callback: {
      success: {
        title: "Inscription réussie",
        description: "L'email de votre compte a été validé avec succès",
      },
      invites: {
        installer: {
          title: "Vous êtes invité pour rejoindre votre équipe solaire",
          description:
            "Veuillez confirmer l’invitation pour créer votre compte à vous et obtenir l’accès à l’espace professionnel en ligne.",
        },
        user: {
          title: "",
          description: "",
        },
        lead: {
          title: "",
          description: "",
        },
      },
      buttons: {
        "resend-callback-link": "Resend activation link",
        "send-callback-link": "Resend activation link",
      },
      verifying: {
        title: "We are verifying that it is really you...",
        description: "We are currently verifying your access, please wait..."
      },
      errors: {
        "token-invalid": "Your activation link is invalid",
        "token-missing": "Your activation link is invalid",
        "token-expired": "Your activation link has expired",
        title: "There was a problem...",
        button: "Return to homepage"
      }
    },
    password: {
      required: "The password is required",
      "min-length": "The password must contain at least 8 characters",
      "upper-case": "The password must contain at least one uppercase letter",
      "lower-case": "The password must contain at least one lowercase letter",
      symbol:
        "The password must contain at least one special character ($!%*?&)",
      number: "The password must contain at least one number",
    },
    "phone-number": {
      label: "Phone number",
      placeholder: "0-00-00-00-00",
    },
    invite: {
      title: "Congratulations, your establishment already has an account!",
      description:
        "The SIRET {siret} of the company is already registered with projetsolaire.",
      button: "Log in",
    },
    errors: {
      duplicateEmailEnabled:
        "Your email is associated with an existing account.",
      duplicateEmailNotEnabled:
        "Your email is associated with an existing but not activated account. Please check your inbox.",
      "account-not-enabled":
        "An installer has already started a project on your behalf. You can access your project by requesting an activation link. You will only need to activate your account and set your password with the link received by email.",
      "account-not-enabled-description":
        "Your email is associated with an existing but not activated account. Please check your inbox.",
      unknown: "An error has occurred.",
    },
    "email-sent": {
      title: "Activation email sent",
      description:
        "A new activation email has been sent. Check your inbox to activate your account.",
    },
    "pv-magazine-testimonial": "“The team is really attentive to my requests to improve the app. The application improves every week.”",
  },

  home: {
    hero: {
      "at-my-place": "At my place",
      professional: "Professional",
      "solar-storage": "Solar + Storage",
      headline: {
        before: "Get ",
        highlight: "the best quotes",
        after: " for your solar projects.",
      },
      description:
        "Choose the cheapest and best offer for your solar investment, from local solar+storage installers.",
      "get-best-price": "Get best price",
      "calculate-savings": "Calculate savings",
      features: {
        noSubcontracting: "No subcontracting",
        noCalling: "No calling",
        noStringsAttached: "No strings attached",
      },
    },

    "how-it-works": {
      tagline: "1,2,3 go",
      title: "How does the first online bidding platform work?",
      subtitle:
        "Receive and compare multiple detailed quotes while remaining anonymous.",
      stepLabel: "Step",
      "step1-title": "Get at least 4 competitive quotes from local installers",
      "step2-title": "Pick your price!",
      "step2-bullet1": "Avoid scams",
      "step2-bullet2": "Obligatory technical visits",
      "step3-title": "Start free permit application",
      "step3-bullet1": "Get a head start",
      "step3-bullet2": "Fastest",
      "step4-title": "Quality Control",
    },

    "vetted-local-artisans": {
      tagline: "Across the country, and near you",
      title: "Vetted Local Artisans",
      description: "Only RGE-certified installers, verified monthly.",
      "directory-button": "Visit the directory",
      "start-with-installer": "Start with this installer",
    },

    videos: {
      tagline: "In their words",
      title: "The best in the business",
      description:
        "Every installer on our platform is RGE-certified, insured, and actively working in your area.",
      "no-video": "No video",
      pause: "Pause",
      play: "Play",
      "aria-previous-video": "Previous video",
      "aria-next-video": "Next video",
      "aria-expand": "Expand",
    },

    "our-results": {
      tagline: "Our results",
      title:
        "We are the no. 1 orchestrators of solar projects all around the country",
      "map-tooltip": "{count} Projects in {name}",
      "stat-1-value": "4 proposals",
      "stat-1-description": "Companies by posted project, average",
      "stat-2-value": "100 +",
      "stat-2-description": "Local photovoltaic installers, all certified RGE",
      "stat-3-value": "40 %",
      "stat-3-description": "Discount on the estimate amount, average",
      "stat-4-value": "3,000 +",
      "stat-4-description": "Solar projects made possible on our community platform",
    },

    "customer-testimonials": {
      tagline: "Customers",
      title: "Hear it from our customers",
      subtitle: "From quote to kWh: their stories",
      "system-power": "System power",
      "battery-power": "Battery power",
      autonomy: "Autonomy",
      roi: "ROI",
      "per-year": "per year",
    },

    solutions: {
      tagline: "Energy Solutions",
      title: "What you can do with your production",
      subtitle: "We support it all",
      "read-more": "Read more",
      items: {
        "off-grid": {
          title: "Off grid solar",
          description:
            "Full energy independence. Generate, store, and use your own power without relying on the grid.",
        },
        "virtual-battery": {
          title: "Virtual Battery",
          description:
            "Store your surplus on the grid and draw it back when you need it — no physical battery required.",
        },
        "sell-to-grid": {
          title: "Selling back to grid",
          description:
            "Produce more than you use? Sell your excess to EDF OA and let your roof generate revenue.",
        },
        "variable-rates": {
          title: "Selling at variable rates",
          description:
            "Maximize returns by selling your surplus at real-time market rates instead of fixed tariffs.",
        },
        "community-solar": {
          title: "Community solar",
          description:
            "Share a solar installation with your neighbors. Lower costs, same clean energy.",
        },
        "total-resale": {
          title: "Total Resale",
          description:
            "Sell 100% of your production to the grid and turn your roof into a pure income source.",
        },
      },
    },

    "image-hotspots": {
      tagline: "All-in-one",
      title: "Your home, fully equipped",
      description:
        "Solar panels, batteries, EV chargers — one platform to plan it all.",
      "read-more": "Read more",
      products: {
        "plug-play": {
          title: "Plug and play kit",
          description:
            "Start producing solar energy in minutes. Just plug it in — no installer, no permits, no roof work needed.",
        },
        roof: {
          title: "Roof Installation",
          description:
            "Get a full study of your energy autonomy, savings, and payback period — tailored to your roof and consumption.",
        },
        battery: {
          title: "Install a battery",
          description:
            "Store your solar energy for the evening and cloudy days. Use more of what you produce and rely less on the grid.",
        },
        "car-charger": {
          title: "Install a car charger",
          description:
            "Charge your EV with your own solar power. Cut fuel costs and charging bills in one go.",
        },
        heater: {
          title: "Install a heater",
          description:
            "Switch to electric heating powered by your panels. Lower your energy bill and stop depending on gas.",
        },
      },
    },

    "how-to-achieve": {
      tagline: "Technology",
      title: "How to achieve autonomy?",
      description:
        "There is a climate urgency. We all need to transition to clean energy quickly.",
      "read-more": "Read more",
      steps: {
        "step-1": {
          title: "Choose your solar system",
          description:
            "Get a study of your electrical autonomy percentage and your potential savings.",
        },
        "step-2": {
          title: "Choose your custom quote",
          description:
            "Receive multiple complete and detailed proposals from certified photovoltaic installers.",
        },
        "step-3": {
          title: "Validate the project's feasibility",
          description:
            "A certified technician visits your home to assess the technical feasibility and confirm installation specifications.",
        },
        "step-4": {
          title: "Choose your quote",
          description:
            "Compare the proposals you've received, select the offer that best fits your needs, and sign your quote online.",
        },
        "step-5": {
          title: "Approvals",
          description:
            "We handle all the administrative steps for you: town hall declaration, CONSUEL electrical safety approval, and Enedis grid connection.",
        },
        "step-6": {
          title: "Installation & commissioning",
          description:
            "Your certified installer fits your solar panels and commissions your system. You start producing your own electricity.",
        },
      },
    },

    "how-to": {
      title: "How to go solar?",
      "steps-title": "The steps.",
      description:
        "We aim to streamline, secure, and democratize large-scale photovoltaic installations, through a few simple steps that we take, with you.",
      "check-full-guide": "Check out the full guide",
      steps: {
        analyze: {
          title: "Analyze",
          description:
            "We estimate your autonomy and savings with a high end study, we then send you a presentation",
          duration: "1 week",
        },
        "compare-hire": {
          title: "Compare and Hire",
          description: "Receive detailed quotes from nearby RGE installers.",
          duration: "1 week",
        },
        regulations: {
          title: "Regulations",
          description: "Urbanisme and grid steps handled with you.",
          duration: "1 month",
        },
        installation: {
          title: "Installation",
          description: "Your system is fitted, commissioned, and connected.",
          duration: "1 week",
        },
      },
    },

    "why-us": {
      title: "Pourquoi passer au solaire avec nous ?",
      description:
        "Nous vous encadrons la réalisation de votre projet solaire. Notre plateforme communautaire repose sur des principes simples : transparence des offres des maitres d'œuvres, parcours à votre rythme, sans engagements. Le service est gratuit pour les particuliers.",
      features: {
        model: {
          title: "Get a in-depth customised solar model",
          description:
            "We take your real historic consumption data from the grid and combine that with an estimate of your solar production using Lidar to produce a 25 year financial model of your own solar project.",
        },
        installers: {
          title: "Get quotes from trusted installers",
          description:
            "We have a network of installers ready to quote on your project. Benefit from a wide range of options and achieve a better price",
        },
        administration: {
          title: "Take care of your administration",
          description:
            "Let us take care of all your administration as part of the solar installation journey. Track its progress online or on your mobile.",
        },
        support: {
          title: "Support all the way until installation day",
          description:
            "Any questions during your installation journey? We are here for you, we have a dedicated staff ready to answer any questions you may have",
        },
      },
    },
    stats: {
      "our-track-record": "Our track record",
      title: "Weve helped homes all across France go solar",
      subtitle: "By Solar professionals, for everyone.",
      description:
        "Connecting individuals going solar with installation experts, making the transition to solar in France simpler than ever.",
      "about-us-button": "About us",
      "stats-value": {
        "3-quotes-guarantee": {
          title: "Entreprises par appel d'offres, moyenne",
          value: "4 propositions",
        },
        "installers-in-network": {
          title: "Installateurs photovoltaïques chez nous",
          value: "1200 +",
        },
        "cost-reduction": {
          title: "Réduction sur montant du devis, moyenne",
          value: "40 %",
        },
        "aided-solar-projects": {
          title: "Projets solaires rendus possible",
          value: "10 000 +",
        },
      },
    },

    "logo-cloud": {
      title: "Discover our customers' testimonials",
      description: "From quote to kWh: their stories",
      readNow: "Read",
      moreCaseStudies: "More case studies",
      testimonials: {
        john: {
          testimonial:
            "Their support is unmatched. Already recommended to 8 friends!",
        },
        mathilde: {
          testimonial:
            "When we had damage in our house, projetsolaire was always there.",
        },
        michel: {
          testimonial:
            "The only project among our ongoing work that went well. The price of the solar panel is more than reasonable.",
        },
      },
    },
    stories: {
      title: "Hundreds of local businesses",
      description:
        "They submit proposals, you compare and choose the best one. You win.",
      button: "Discover all stories",
    },

    community: {
      title: "Join our community of solar projects",
      description:
        "We have helped people go solar all across France. Start your solar journey today and join the rest of France on the national solar mission",
    },
    newsletter: {
      title: "Subscribe to our newsletter",
      subtitle:
        "Subscribe to our newsletter to stay informed of news and updates.",
      placeholder: "Email address",
      button: "Subscribe",
    },
    mission: {
      tagline: "Why us",
      comparisonHeading: "Not all solar paths are equal",
      comparisonDescription:
        "Compare your options. Our platform is free for homeowners — and gives you more for less.",
      title: "Our safety guarantee",
      paragraph1:
        "There are plenty of ways to go solar. Here are a few points that are different with ProjetSolaire.",
      cardTitle: "Verified Local Artisans",
      cardDescription: "Only RGE-certified installers, controlled monthly.",
      card1Title: "Transparent Pricing",
      card1Description: "Multiple competitive rates; you choose.",
      card2Title: "Complete Help",
      card2Description: "From advice to paperwork to commissioning.",
      buttons: {
        regulatory: "Regulatory",
        articles: "Articles",
        learn: "Learn",
        estimator: "Estimator",
      },
      paragraph2: "Make it easier to go solar",
      paragraph3: "End scams",
      paragraph4: "Massively increase the number of solar installations",
      paragraph5:
        "Projetsolaire.com is therefore the solar project of a family, a local business, a community … it is their solar project, it is her solar project. This is finally your solar project too.",
      comparison: {
        title: "Several ways to do it.",
        subtitle:
          "Here is how they differ from each other. This service is free for individuals.",
        freeService: "The service is free for individuals.",
        columns: {
          doItAlone: {
            title: "By yourself",
            features: {
              0: "Price range (€2/W - €3/W)",
              1: "No sales commissions",
              2: "No subcontracting",
              3: "Equipment power (375 W - 400 W)",
              4: "Independent study",
            },
          },
          projetsolaire: {
            title: "Projetsolaire",
            features: {
              0: "Price range (€1/W - €2/W)",
              1: "No sales commissions",
              2: "Competitive bidding",
              3: "No subcontracting",
              4: "Ten-year warranty",
              5: "Equipment power (375 W - 500 W)",
              6: "Independent study",
              7: "Administrative follow-up",
              8: "Third-party control",
            },
          },
          largeGroups: {
            title: "Large Groups",
            features: {
              0: "Price range (€3/W - €5+ /W)",
              1: "Ten-year warranty",
              2: "Equipment power (330 W - 375 W)",
              3: "Administrative follow-up",
            },
          },
        },
      },
    },

    cta: {
      title: {
        line1: "We coordinate the",
        line2: "stakeholders of your solar",
        line3: "project",
      },
      subtitle: "Build, manage, and scale your solar business with confidence.",
      buttonGetStarted: "Get Started",
      buttonBookDemo: "Request a Demo",
      benefit: {
        benefit1: "Competitive salaries",
        benefit2: "Flexible work hours",
        benefit3: "30 days of paid vacation",
        benefit4: "Annual team retreats",
        benefit5: "Benefits for you and your family",
        benefit6: "A great work environment",
      },
      button: "Discover more",
    },

    "action-buttons": {
      "discover-potential": {
        title: "Discover your solar potential",
        description:
          "Quick analysis of your electricity savings from your Linky meter. We calculate the energy, economic, and environmental value of your solar site.",
      },
      "best-price": {
        title: "Get the best price",
        description:
          "Choose your price! Let the competition work for you — companies want to win your project. Let us obtain several complete, detailed, and tailor-made quotes.",
      },
    },

    faq: {
      tagline: "Anything left?",
      title: "All your questions regarding solar",
      "different-question": "Have a different question?",
      "get-call-back": "Get a call back",
      "read-more-blog": "Read more on our blog",
      items: {
        cost: {
          question: "How much does it cost?",
          answer:
            "Through our platform, expect between €1/W and €2/W — significantly less than large national installers who charge €3 to €5+/W. For a typical 3kWc installation, that means roughly €3,000 to €6,000 before any government subsidies.",
        },
        "why-free": {
          question: "Why is the service free?",
          answer:
            "We take a small commission from the installer when a project is completed. You never pay us anything. This model means we only succeed when you get a good installation — our incentives are aligned with yours.",
        },
        profitable: {
          question: "How is solar profitable?",
          answer:
            "A well-sized installation typically pays for itself in 7 to 10 years, then generates free electricity for another 20+ years. You save on your bill immediately, and any surplus can be sold back to EDF OA for additional income.",
        },
        problem: {
          question: "What happens if there is a problem?",
          answer:
            "Every installer on our platform carries insurance and provides a ten-year workmanship warranty. Your panels and inverter come with manufacturer guarantees of 20 to 25 years. We also offer third-party quality control and administrative follow-up after installation.",
        },
        "get-started": {
          question: "How to get started?",
          answer:
            "Enter your address, answer a few questions about your energy usage, and receive a free solar study within minutes. From there, you can browse available installers in your area and request quotes — all at no cost.",
        },
      },
    },

    "lead-flow": {
      address: {
        title: "Where is your solar site located?",
        subtitle: "Enter your address below",
        buildingNotFoundDescription:
          "Your building is not the one indicated by the pin? Drag it to the exact point.",
        continueButton: "Next",
      },
      "project-type": {
        dismiss: "Dismiss",
        next: "Next",
      },
    },
  },

  blog: {
    hero: {
      all: {
        title: "Blog",
        subtitle:
          "Everything you need to go solar in France, by the solar company.",
      },
      learn: {
        title: "Learn",
        subtitle:
          "General guides and content prepared by Projet Solaire's editorial team gathered in one place, sorted by date.",
      },
      articles: {
        title: "Solar Guide",
        subtitle:
          "Your ultimate guide to solar energy! All the essential information you need to reduce your costs and invest in a better and sustainable future.",
      },
      regulatory: {
        title: "Regulatory and Legal",
        subtitle:
          "A selection of our articles covering the regulatory standpoint when going solar.",
      },
      testimonials: {
        title: "Testimonials",
        subtitle: "Our customers' feedback after installation.",
      },
    },
    tabs: {
      all: "All",
      learn: "Learn",
      articles: "Articles",
      regulatory: "Regulatory",
      testimonials: "Testimonials",
    },
    "installation-steps": {
      title: "Go solar",
      subtitle:
        "We are developing a custom community platform that connects all solar project holders with professionals in photovoltaics and storage.",
      "read-more": "Read more",
    },
    featured: {
      title: "Solar, in six episodes",
      subtitle:
        "Discover the latest info on solar energy, backed by answers to your most common questions.",
    },
    latest: {
      title: "New articles",
      subtitle:
        "Stay up to date on the latest articles from our independent editorial team.",
      by: "written by ",
      "search-placeholder": "Search all articles",
      "see-all": "See all",
    },
    series: {
      topics: "Topics",
      "topics-series": {
        stories: "Stories",
        "why-go-solar": "Why go solar",
        "how-to-go-solar": "How to go solar in France ?",
      },
    },
    popular: {
      "popular-on": "Popular on Projetsolaire",
      by: "By ",
    },
    regulatory: {
      title: "Regulatory",
      subtitle:
        "General guides and content prepared by Projet Solaire's editorial team, gathered in one place, sorted by date.",
      "search-placeholder": "Search regulatory and legal",
      "see-all": "See all",
    },
    "image-links": {
      roof: {
        title: "Discover your solar potential",
        description:
          "Quick analysis of your electricity savings from your Linky meter. We calculate the energy, economic and environmental value of your solar resource.",
      },
      software: {
        title: "Get the best price",
        description:
          "Choose your price! Let competition work for you, companies want to win your project. Let us get several complete, detailed and tailor-made quotes.",
      },
    },
  },

  about: {
    "mission-statement":
      "<span class='opacity-50'>Our</span> mission <span class='opacity-50'>is</span><br /> to solve residential solar <br /> in France",
    intro: {
      title: "We enable solar projects to happen",
      description:
        "Our aim is to transform solar project installation, making it faster, cheaper, simpler... better!",
    },
    story: {
      title: "Our journey",
      "paragraph-1": ".",
      "paragraph-2": "",
      "paragraph-3": "",
      "paragraph-4": "",
      "paragraph-5": "",
      "paragraph-6":
        "Implantée en Provence, notre startup innovante compte trois cofondateurs-associés. À ce jour, nous n’avons jamais eu besoin de lever de l’argent ni de dépenser un seul euro en publicité. Au contraire, notre méthode c’est la satisfaction client et le bouche-à-oreille.",
      "paragraph-7": "",
      "paragraph-8": "",
    },
    stats: {
      title: "Acteur de l’indépendance énergétique de France.",
      description:
        "Notre plateforme communautaire réunit tous les porteurs de projets solaires avec les professionnels du photovoltaïque ; ensemble avec tous les acteurs de la transition énergétique - bureaux d’études, fournisseurs, financiers, municipalités, services publics.",
      "flagship-projects":
        "Nous nous sommes élancé dans le solaire lors du premier confinement.",
      "installers-on-our-platform":
        "Artisans sur notre plateforme communautaire.",
      "solar-projects-enabled": "Projets solaires propulsés.",
      followers: "Followers",
    },
    team: {
      header: {
        badge: "Our team",
        title: "The team behind the technology",
        description:
          "We're a dynamic group of individuals who are passionate about what we do and dedicated to delivering the best results for our clients.",
      },
      title: "L'équipe derrière la technologie",
      description:
        "We're a dynamic group of individuals who are passionate about what we do and dedicated to delivering the best results for our clients.",
      people: {
        "person-1": {
          name: "Yann",
          role: "Operations lead & Co-founder",
          bio: "Yann Vermeil Schremmer continue d'imaginer de nouveaux modes de fonctionnement en interne, puis coordonne les divers interlocuteurs externes pour allier au mieux l’entreprenariat avec l’environnement.",
        },
        "person-2": {
          name: "Maarten",
          role: "CTO & Co-founder",
          bio: "Maarten Elgar développe la technologie qui aide les foyers à se mettre à l'énergie solaire en leur permettant d'obtenir des devis d'installateurs de confiance, puis de faire réaliser le reste du parcours en ligne.",
        },
        "person-3": {
          name: "Georges",
          role: "Sales lead & Co-founder",
          bio: "Georges Séraphim-André Nevsky aide les françaises et de français à découvrir leur potentiel solaire puis définir leur projet sur-mesure. Il aide les artisans photovoltaïques à bénéficier des nouvelles technologies de pointe.",
        },
        "person-4": {
          name: "Aurélie",
          role: "Head of administration",
          bio: "Aurélie Aparicio accompagne les professionnels dans leurs démarches technico-administratives de conformité, en apportant sécurité et toute l’aide aux citoyens voulant passer par la bureautique de l'énergie solaire..",
        },
        "person-5": {
          name: "Kelly",
          role: "Head of Design & Junior Developer",
          bio: "Aurélie Aparicio accompagne les professionnels dans leurs démarches technico-administratives de conformité, en apportant sécurité et toute l’aide aux citoyens voulant passer par la bureautique de l'énergie solaire..",
        },
        "person-6": {
          name: "Sebastian",
          role: "Front-end Engineer",
          bio: "Aurélie Aparicio accompagne les professionnels dans leurs démarches technico-administratives de conformité, en apportant sécurité et toute l’aide aux citoyens voulant passer par la bureautique de l'énergie solaire..",
        },
      },
    },
  },

  career: {
    navigation: {
      directory: "Annuaire Artisans RGE",
      ambassadors: "Ambassadors",
      careers: "Careers",
      blog: "Blog",
      about: "About us",
      product: "Product",
      menu: "Menu",
    },
    title: "Projetsolaire is growing. Grow with us.",
    description:
      "We are based in Marseille and looking for people to join our passionate team. Interested in working in renewable energy and helping people go solar? Join us now",
    home: {
      title: "Want to do something <br /> great?",
      description:
        "Join us to help everyone everywhere access solar energy - clean, free and independent.",
      mission: {
        label: "Fighting climate injustice",
        title: "Our mission",
      },
    },
    openings: {
      title: "Current open positions",
      "fullstack-engineer": "Senior fullstack engineer",
      "junior-frontend-engineer": "Junior frontend engineer",
      "junior-account-representative": "Junior account representative",
      "account-representative": "Senior account representative",
      "job-openings": "Job openings",
      role: "Role",
      description: "Description",
      salary: "Salary",
      location: "Location",
      "view-all-openings": "View all openings",
    },
    process: {
      "step-1": {
        title: "Apply",
        description:
          "Duis aute irure dolor in reprehenderitin volupta velit esse cillum sint occaecat cupidatat.",
      },
      "step-2": {
        title: "Screening",
        description:
          "Duis aute irure dolor in reprehenderitin volupta velit esse cillum sint occaecat cupidatat.",
      },
      "step-3": {
        title: "Interview",
        description:
          "Duis aute irure dolor in reprehenderitin volupta velit esse cillum sint occaecat cupidatat.",
      },
      "step-4": {
        title: "Job Offer",
        description:
          "Duis aute irure dolor in reprehenderitin volupta velit esse cillum sint occaecat cupidatat.",
      },
    },
    cta: {
      text: "Sounds like we are building something cool?",
      button: "Join us today",
    },
    stats: {
      title: "Accelerating the solar <br /> revolution",
      description1:
        "For the first time since the industrial revolution, citizens can produce their own energy. We are building the best tech in the world for a bright future in the face of climate urgency.",
      description2:
        "We embarked on solar as soon as we understood how difficult it is for our parents to become self-sufficient in clean energy, despite the tremendous progress in photovoltaic technologies.",
      stat1: {
        value: "+122 MW",
        label: "of solar projects",
      },
      stat2: {
        value: "+8000",
        label: "solar projects",
      },
      stat3: {
        value: "+1000",
        label: "professionals",
      },
    },
    coreValues: {
      value1: {
        title: "Customer first",
        description:
          "The operational excellence of our teams at the best price for our customers is non-negotiable.",
      },
      value2: {
        title: "Speed",
        description:
          "We ship articles quickly. We respond immediately. We act fast.",
      },
      value3: {
        title: "Teamwork",
        description:
          "We are a small team of superstars. We accomplish everything together. Our magic recipe: pragmatism and kindness.",
      },
    },
    quote: {
      text: "They can because they think they can.",
      attribution: "Virgil - Aeneid, Book 5",
    },
    growth: {
      title: "Our projetsolaire is growing.<br /> Grow with us.",
      description:
        "Based in Provence, we are looking for talents to flourish and prosper. Want to have an impact on the climate by helping our fellow citizens make the solar revolution? Welcome!",
      button: "View open positions",
    },
    apply: {
      title: "Apply for position",
      subtitle:
        "Tell us about you ! Complete the form below to submit your application.",
    },
    commitments: {
      FULL_TIME: "Full time",
      PART_TIME: "Part time",
      INTERNSHIP: "Internship",
      CONTRACT: "Contract",
      COFOUNDER: "Director",
    },
    roles: {
      COFOUNDER: "Director",
      PROGRAMMING: "Programming",
      CONTRACT: "Self-employed",
      DESIGN: "Design",
      MANAGEMENT: "Management",
      BUSINESS_DEVELOPMENT: "Business development",
      SALES_AND_MARKETING: "Sales and marketing",
      ADMINISTRATION: "Administration",
      OPERATIONS: "Operations",
      SERVICE_CLIENT: "Service Client",
    },
    roleDescriptions: {
      COFOUNDER: "Director role description",
      PROGRAMMING: "Programming role description",
      CONTRACT: "Contract role description",
      DESIGN: "Design role description",
      MANAGEMENT: "Management role description",
      BUSINESS_DEVELOPMENT: "Business development role description",
      SALES_AND_MARKETING: "Sales and marketing role description",
      ADMINISTRATION: "Administration role description",
      OPERATIONS: "Operations role description",
      SERVICE_CLIENT: "Service client role description",
    },
    post2: {
      intro: {
        label: "Careers at projetsolaire",
        title: {
          colored: "Join us",
          rest: " to make an impact on solar energy.",
        },
        description:
          "We are building the future of clean, decentralized energy in the south of France, surrounded by some of the most beautiful landscapes in the world.",
      },
      opportunities: {
        title: "Available Opportunities",
        description:
          "We care little about formal education. We are simply looking for people capable of building their future autonomously.",
      },
      operation: {
        title: "Operations",
        description: "Open positions in our operations department",
        job: {
          title: "Account Integration Manager",
          description:
            "More and more professionals want our solutions. Help us support photovoltaic and storage installers.",
          type: "Self-employed",
          role: "Sales",
          location: "Marseille, France",
        },
      },
      service: {
        title: "Customer Service",
        description: "Open positions in our customer service department",
        job: {
          title: "Customer Service Manager",
          description:
            "We are looking for an extremely talented and efficient person to support our growth efforts in France.",
          type: "Full time",
          role: "Business Developer",
          location: "Marseille, France",
        },
      },
      apply: "Apply",
    },
  },

  "dynamic-forms": {
    leads: {
      heading: {
        title: "Bonjour {fullName}!",
        subtitle:
          "Pour nous aider à modéliser le potentiel solaire de votre maison, nous avons besoin de quelques informations. Cela ne vous prendra que quelques minutes !",
      },
      "verifying-token": "Vérification de votre accès",
      submitted: "Vous avez partagez vos informations avec succès !",
      steps: {
        "customer-information": {
          title: "Vos informations personnelles",
          subtitle: "Confirmer vos informations personnelles",
        },
        address: {
          title: "Votre adresse",
          subtitle: "Confirmer votre adresse",
        },
        "electricity-bill": {
          title: "Votre facture d électricité",
          subtitle: "Télécharger votre facture d'électricité",
          "paragraph-1":
            "Pour pouvoir modéliser votre maison avec précision, nous avons besoin de votre facture d'électricité. Cela nous aide à projeter vos rendements avec votre contrat d'électricité réel.",
        },
        confirm: {
          title: "Envoyez vos informations",
          subtitle:
            "Une fois que vous êtes satisfait, soumettez vos informations pour votre modèle personnalisé",
          "paragraph-1":
            "Si vous êtes satisfait de vos informations, cliquez sur 'Envoyer' et nous commencerons à préparer votre modèle personnalisé dans les 48 heures.</br>",
        },
      },

      errors: {
        "token-invalid": "L'accès est invalide",
        "token-missing": "L'accès est invalide",
      },
    },
    administration: {
      heading: {
        title: "Bonjour {fullName}!",
        subtitle:
          "Pour compléter vos services, nous avons besoin de quelques informations. Cela ne vous prendra que quelques minutes à remplir !",
        "subtitle-for-installer":
          "Pour compléter les services de {customerName} au {fullAddress}, nous avons besoin des informations suivantes. Cela ne vous prendra que qu'une seule minute à remplir !",
      },

      submitted: "Vous avez partagez vos informations avec succès !",
      "verifying-token": "Vérification de votre accès",
      steps: {
        "customer-information": {
          title: "Vos informations personnelles",
          subtitle: "Confirmer vos informations personnelles",
        },
        address: {
          title: "Votre adresse",
          subtitle: "Confirmer votre adresse",
        },
        documents: {
          title: "Documents",
          subtitle:
            "Télécharger le document demandé pour compéter votre services",
          "paragraph-1":
            "Pour pouvoir modéliser votre maison avec précision, nous avons besoin de votre facture d'électricité. Cela nous aide à projeter vos rendements avec votre contrat d'électricité réel.",
          "property-deed": "titre de propriété",
          "identity-document": "Identity document",
          "mayor-approval": "Permitting approval",
          "electricity-bill": "facture électrique",
          "consuel-approval": "AC du Consuel",
          "manual-mayor-single-mandate":
            "Signature du mandat spécial de représentation - Autorisation d’urbanisme",
          "manual-enedis-single-mandate":
            "Signature du mandat spécial de représentation - Demande de raccordement",
          "wiring-diagram": "Schéma électrique unifilaire",

          esign: {
            "mayor-single-mandate":
              "Signature du mandat spécial de représentation - Autorisation d’urbanisme",
            "enedis-single-mandate":
              "Signature du mandat spécial de représentation - Demande de raccordement",
            "dual-mandate": "Signature du mandat spécial de représentation",
          },
        },
        hardware: {
          title: "Matériel",
          subtitle: "Ajouter l'inventaire avec lequel le système est installé",
          panelLayoutDescription: "Description du calepinage",
          panel: "Panneaux",
          inverter: "Onduleur",
        },
        technicals: {
          title: "Technicals",
          subtitle: "Ajouter les informations techniques de l'installation",
          "paragraph-1":
            "Si vous êtes satisfait de vos informations, cliquez sur 'Envoyer' et nous commencerons à préparer votre modèle personnalisé dans les 48 heures.</br>",
          "system-size": "puissance de l’installation solaire (kVa)",
          "usage-point": "numéro du Point De Livraison (PDL)",
          "grid-connection-types": "monophasé ou triphasé ?",
          "monophase-grid-connection": "monophasé",
          "triphase-grid-connection": "triphasé",

          "meter-container-sizes": "largeur du coffret",
        },
        confirm: {
          title: "Envoyez vos informations",
          "paragraph-1":
            "Confirmez que vous êtes d'accord pour soumettre toutes les informations saisies. Nous commencerons alors à compléter vos services pour vous.</br>",
        },
      },

      errors: {
        "token-invalid": "L'accès est invalide",
        "token-missing": "L'accès est invalide",
      },
    },
  },

  support: {
    home: {
      title: "Get in touch with our team",
      subtitle:
        "Select a category to email the support team or contact us directly by using the form below.",
      "get-in-touch": "Prendre contact",
      "support-card": {
        "start-solar-autonomy": {
          name: "Démarrer autonomie solaire",
          description:
            "Envie de bénéficier d'un conseil pro bono ? Prenez contact avec notre conseil indépendant pour particuliers.",
        },
        "for-industry-farmers": {
          name: "Pour industriels & agriculteurs",
          description:
            "Vous portez un projet solaire de grande puissance ? Prenez contact avec notre équipe au service des installateurs photovoltaïques.",
        },
        "for-photovoltaic-professionals": {
          name: "Pour artisans photovoltaïques",
          description:
            "Besoin de précisions sur nos solutions informatiques ? Prenez contact avec notre équipe technico-administrative pour professionnels.",
        },
        "technical-support": {
          name: "Support technique",
          description:
            "Besoin d'aide sur dépannage technique sur votre compte ? Prenez contact avec notre équipe informatique.",
        },
        "solar-partnerships": {
          name: "Partenariats solaires",
          description:
            "Vous recherchez des solutions informatiques pour le domaine photovoltaïque ? Prenez contact pour des opportunitées de partenariat.",
        },
        press: {
          name: "Presse",
          description:
            "Besoin de nous joindre ? Prenez contact avec notre relation presse.",
        },
      },
    },
    "our-office": {
      title: "Come visit us at our office!",
      subtitle:
        "Located in the Old Port of Marseille, we chose a headquarters in an old art workshop, next to the Memorial of La Marseillaise, to contribute to the regeneration of the neighborhood.",
      location: {
        region: "Provence",
        address: "11 rue Thubaneau, 13001 Marseille, France",
      },
      maps: "Show in Maps",
    },

    "help-center": {
      title: "Explore our help centre for more information",
      subtitle:
        "We have alot of guides that may be useful in helping resolving your question",
    },
    schedule: {
      "chat-online": "Vous préférez discuter directement avec nous en ligne ?",
      "open-chatbox": "Ouvrir messagerie.",
      residential: {
        heading: "Pour particuliers",
        description:
          "Envie de bénéficier d'un conseil pro bono ? Prenez contact avec notre conseil indépendant pour particuliers.",
        breadcrumb: {
          name: "Démarrer son autonomie solaire",
        },
      },
      business: {
        heading: "Pour industriels & agriculteurs",
        description:
          "Vous portez un projet solaire de grande puissance ? Prenez contact avec notre équipe au service des installateurs photovoltaïques.",
        breadcrumb: {
          name: "Pour industriels & agriculteurs",
        },
      },
      installer: {
        heading: "Pour installateurs photovoltaïques",
        description:
          "Besoin de précisions sur nos solutions informatiques ? Prenez contact avec notre équipe technico-administrative pour professionnels.",
        breadcrumb: {
          name: "Pour installateurs photovoltaïques",
        },
      },
      "technical-support": {
        heading: "Support technique",
        description:
          "Besoin d'aide sur dépannage technique sur votre compte ? Prenez contact avec notre équipe informatique.",
        breadcrumb: {
          name: "Support technique",
        },
      },
      partnerships: {
        heading: "Partenariats solaires",
        description:
          "Vous recherchez des solutions informatiques pour le domaine photovoltaïque ? Prenez contact pour des opportunitées de partenariat.",
        breadcrumb: {
          name: "Partenariats solaires",
        },
      },
      press: {
        heading: "Presse",
        description:
          "Besoin de nous joindre ? Prenez contact avec notre relation presse.",
        breadcrumb: {
          name: "Presse",
        },
      },
    },
  },
  help: {
    header: {
      title: "Help Centre",
    },
    home: {
      label: "Help and assistance",
      title: "Which one are you?",
      description:
        "Tell us more about you so we can tailor the articles to your needs.",
      householder: "I am a householder",
      installer: "I am an installer",
    },
    householder: {
      label: "Help articles",
      title: "How can we help you?",
      guides_title: "All topics",
      description:
        "In-depth technical guides, as well as answers to all your questions.",
      sections: {
        "getting-started": {
          title: "Getting Started",
          storage: {
            title: "Storage Solutions",
          },
          offers: {
            title: "Offers and installations",
          },
          "pros-cons": {
            title: "Advantages and disadvantages",
          },
          financing: {
            title: "Aid and financing",
          },
          maintenance: {
            title: "Maintenance",
          },
        },
        portal: {
          title: "Your online portal",
        },
        payments: {
          title: "Payment, pricing and refunds",
        },
        process: {
          title: "The solar installation process in depth",
          "choosing-system": {
            title: "Choosing your system",
          },
          "tailor-made-quote": {
            title: "Choosing your tailor-made quote",
          },
          "validate-feasibility": {
            title: "Validate feasibility",
          },
          administrative: {
            title: "Carrying out administrative procedures",
          },
          installation: {
            title: "Installation and commissioning",
          },
        },
        legal: {
          title: "Legal notices",
        },
      },
      guides: {
        "your-internet-portal": {
          title: "Your internet portal",
          description:
            "Easy-to-follow instructions for creating an account and managing your online space.",
        },
        "payments-pricing-and-refunds": {
          title: "Payments, pricing and refunds",
          description:
            "Steps to fully realize your economic gain, compare euro-watt-peak prices, pay the deposit and balance, and download invoices and receipts.",
        },
        "choose-your-solar-system": {
          title: "Choosing your solar system",
          description:
            "How to benefit from a study of your percentage of electrical autonomy, and therefore your savings, compared to different alternatives for your solar project.",
        },
        "choosing-a-customised-quote": {
          title: "Choosing your customized quote",
          description:
            "How to select from several complete, detailed and tailor-made proposals from photovoltaic installers near you.",
        },
        "validate-feasibility": {
          title: "Validate feasibility",
          description:
            "How to plan and then prepare for the meeting with the technician, and have the technical feasibility of the specifications carried out at your home.",
        },
        "investing-in-solar": {
          title: "Investing in solar",
          description:
            "How to check the insurance and certifications of the project manager, electronically sign your final quote, and pay the deposit securely.",
        },
        "carrying-out-administrative-procedures": {
          title: "Carrying out administrative procedures",
          description:
            "How to monitor the obtaining of urban planning authorization from the town hall, then plan the photovoltaic installation.",
        },
        "installation-and-commissioning": {
          title: "Installation & commissioning",
          description:
            "How to enhance the injection of surplus with a connection to the electricity grid respecting the standards in force.",
        },
        "legal-notices": {
          title: "Legal notices",
          description:
            "Information on the contractual relationship between us and the photovoltaic professional, with an overview of the general conditions.",
        },
      },
      cta: {
        title: "Discover others solar journey",
        subtitle:
          "See how other homeowners have transformed their energy consumption with solar.",
        description:
          "Join thousands of families across France who are already producing their own clean energy.",
        button: "Join our community",
      },
    },
    installer: {
      label: "Help articles",
      title: "How can we help you?",
      description:
        "In depth, technical guides as well as answers to your questions, organized.",
      videos: {
        title: "Video Tutorials to get started",
        description:
          "Check out our video tutorials to get familiar with our platform and services.",
        expand: "Expand",
      },
      guides: {
        "your-online-account": {
          title: "Votre compte en ligne",
          description:
            "Instructions faciles à suivre pour créer un compte et gérer son espace professionnel.",
        },
        "your-solar-projects": {
          title: "Vos projets solaires",
          description:
            "Instructions simples à suivre pour la gestion et le suivi de prospects, devis, dossiers puis chantiers photovoltaïques sur une seule interface en ligne.",
        },
        "online-photovoltaic-studies": {
          title: "Études photovoltaïques en ligne",
          description:
            "Tout savoir sur comment mieux vendre avec nos présentations personnalisables, vos propositions sur-mesure de systèmes solaires, et notre méthode technico-financière.",
        },
        "dematerialised-administrative-management": {
          title: "Gestion administrative automatisée",
          description:
            "Tout savoir sur comment gagner du temps avec nos services numériques d’envoi et de suivi des démarches administratives obligatoires pour installations photovoltaïques.",
        },
        "contact-and-quotation-proposals": {
          title: "Discover new clients",
          description:
            "Tout savoir sur les signatures électroniques, les paiements automatiques sur internet, la mise en conformité, le service d’assistance de maîtrise d’ouvrage, et bien plus encore. ",
        },
        "materials-planning": {
          title: "Planification du matériel",
          description:
            "Tout savoir sur les listes de matériel de l’entreprise, kits personnalisables, approvisionnement et gestion du stock, comptes rendus de chantiers, et bien plus encore.",
        },
        "after-sales-service": {
          title: "Service après-installation",
          description:
            "Tout savoir sur la responsabilité de chacun, communication entre le maitre d’ouvrage et le maitre d’œuvre, l’entretien, le suivi de rendements, le dépannage et le nettoyage.",
        },
        "payments-pricing-and-refunds": {
          title: "Paiements, tarification et remboursements",
          description:
            "Marche à suivre pour percevoir de l’argent, gagner du chiffre d’affaires, acheter au travers de la boutique en ligne, et télécharger les factures comptables.",
        },
        "legal-notices": {
          title: "Mentions juridiques",
          description:
            "Informations sur la relation contractuelle entre nous et le professionnel photovoltaïque, avec aperçu des conditions générales mentions légales.",
        },
      },
      cta: {
        title: "Join our platform",
        description:
          "Lorem ipsum dolor sit amet consect adipisicing elit. Possimus magnam voluptatum cupiditate veritatis in accusamus quisquam.",
        benefit: {
          benefit1: "Competitive salaries",
          benefit2: "Flexible work hours",
          benefit3: "30 days of paid vacation",
          benefit4: "Annual team retreats",
          benefit5: "Benefits for you and your family",
          benefit6: "A great work environment",
        },
        button: "Sign up now",
      },
    },
    "side-bar": {
      "bread-crumb": {
        help: "Help",
      },
      search: "Search",
      "for-anything": "for anything",
      placeholder: "...",
    },
    article: {
      "interested-more": "Interested in more tips and advice?",
      "back-to-help": "Back to help centre",
    },
  },
  "learn-centre": {
    article: {
      "interested-more": "Interested in more tips and advice? Check",
      "back-to-learn": "Back to learn centre",
    },
  },

  common: {
    tender,
    loading: "Loading...",
    processing: "Chargement...",
    warning: "Alerte !",
    brandName: "projetsolaire",
    copyright: "2023 © projetsolaire.com. All rights reserved.",
    name: "Name",
    "enter-your-name": "Enter your name",
    email: "Email",
    "enter-your-email": "Enter your email address",
    "your-email": "Your email",
    password: "Password",
    "enter-your-password": "Enter your password",
    siret: "Votre numéro SIRET",
    "enter-your-siret": "Entrez votre SIRET",
    "phone-number": "Votre numéro de téléphone",
    "enter-your-phone-number": "Entrez votre numéro de téléphone",
    "sign-up": "Sign Up",
    "sign-in": "Sign in",
    or: "Ou",
    apply: "Apply",
    optional: "Optional",
    "select-a-tab": "Select a tab",
    title: {
      mr: "Mr",
      mrs: "Mrs",
    },
    "user-types": {
      BUSINESS: "Business",
      RESIDENTIAL: "Residential",
      PUBLIC_AUTHORITY: "Public Authority",
    },
    "not-signed-in": {
      title: "Not logged in",
      description: "Sorry, to access this content you need to be logged in",
      button: "Sign in now",
    },
    "cookie-gdpr": {
      "cookie-text-1":
        "Nous utilisons les cookies pour mettre nos services à votre disposition.",
      "cookie-text-2": "Pour en savoir, veuillez explorer notre ",
      "cookie-link": "Déclaration de Confidentialité",
      accept: "Accepter",
      decline: "Refuser",
    },
    "algolia-search-dialog": {
      search: "Search",
      placeholder: "Search Anything...",
      results: "Results",
      tags: {
        installer: "Installer",
        householder: "Householder",
        "help-center": "Help center",
        blog: "Blog",
      },
    },
    verifying: {
      title: "Verifying",
      title2: "Verifying that its you",
      description: "We are verifying your access, please bear with us",
    },
    error: {
      title: "Oops there was a problem",
      button: "Go back home",
    },
    success: {
      "confirmed-account": "Successfully confirmed your account",
      "sign-in": "Sign in now",
      "reset-password": "Successfully reset password",
      continue: "Continue",
    },
    "page-not-found": {
      title: "This page does not exist.",
      description: "The page you are looking for could not be found.",
      "go-home": "Go back home",
    },
    "newsletter-dialog": {
      title: "Signup to our newsletter",
      description:
        "We send out some new content each month updating you on the latest news with our mission",
      form: {
        "first-name": "First name",
        "last-name": "Last name",
        company: "Company",
        email: "Email",
      },
      "agree-to-policies": "Agree to policies",
      "switch-agree": "By selecting this, you agree to our",
      "privacy-policy": "privacy policy",
      subscribe: "Subscribe",
    },
    month: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December",
    },
    pagination: {
      showing: "Affiche",
      to: "à",
      of: "de",
      results: "résultats",
      previous: "Précédent",
      next: "Suivant",
      related: "Related",
    },
  },

  snackbars: {
    "lead-submitted": "Nous avons reçu votre demande",
    "password-reset-success": "votre mot de passe a été mis à jour.",
    "reset-token-sent":
      "Vérifiez votre boîte mail pour mettre à jour votre mot de passe.",
    "register-success":
      "Vous avez créé votre compte projetsolaire ! Confirmez votre inscription avec le courriel dans votre boîte mail.",
    "login-success": "Bienvenue sur projetsolaire",
    errors: {
      common:
        "Une erreur s’est produite. Veuillez réessayer puis nous contacter si le problème persiste.",
      "password-reset-failed": "La mise à jour du mot de passe a échouée.",
      "login-failed":
        "Connexion échouée : vérifier votre saisie puis réessayer.",
      "register-failed":
        "Nous n’avons pas pu créer votre compte. Veuillez réessayer puis nous contacter si le problème persiste.",
    },
  },
  "resale-agreements": resaleAgreements,
  "meta-tags": metaTags,

  changelog: {
    title: "Changelog",
    description: "Discover the latest features and improvements.",
    "search-placeholder": "Search releases...",
    filter: {
      all: "All",
      web: "Web",
      mobile: "Mobile",
    },
    empty: "No releases found.",
  },
};
